import { AxiosRequestConfig } from 'axios';
import { HttpClient } from 'api/http-client';
import {
  updateTaskAssigneeAndResponsibleCompany,
  updateTasksAssigneeAndResponsibleCompany,
} from 'utils/strategic-partner-utils';
import { Task } from './index';

const transformResponse = <T extends Task | Task[]>(response: T): T => {
  return (
    Array.isArray(response)
      ? updateTasksAssigneeAndResponsibleCompany(response as Task[])
      : updateTaskAssigneeAndResponsibleCompany(response as Task)
  ) as T;
};

export class WithNotStrategicTransformer extends HttpClient {
  getWithTransformer = <T extends Task | Task[]>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<T> =>
    this.get<T, T>(url, config).then((response) => transformResponse(response));

  putWithTransformer = <T extends Task | Task[], B>(
    url: string,
    payload?: B,
    config?: AxiosRequestConfig,
  ): Promise<T> =>
    this.put<T, B, T>(url, payload, config).then((response) =>
      transformResponse(response),
    );

  postWithTransformer = <T extends Task | Task[], B>(
    url: string,
    payload?: B,
    config?: AxiosRequestConfig,
  ): Promise<T> =>
    this.post<T, B, T>(url, payload, config).then((response) =>
      transformResponse(response),
    );
}
